export default "__VITE_ASSET__DLK7$Qxn__"